import { jsx as _jsx } from "react/jsx-runtime";
import MyPageSubLayout from "@/components/myPage/layout/MyPageSubLayout";
import MyPassesPage from "@/components/myPage/passes";
import useRequireLogin from "@/hooks/useRequireLogin";
const MyPagePassesPage = ()=>{
    const { isLoggedIn  } = useRequireLogin();
    if (!isLoggedIn) return null;
    return /*#__PURE__*/ _jsx(MyPageSubLayout, {
        title: "이용권 관리",
        showHeaderBorder: false,
        children: /*#__PURE__*/ _jsx(MyPassesPage, {})
    });
};
MyPagePassesPage.getLayout = (page)=>page;
export default MyPagePassesPage;
